import { DialogActionsClassKey } from '@material-ui/core/DialogActions';

const MuiDialogActions = (): Partial<Record<DialogActionsClassKey, unknown>> => ({
    root: {
        padding: '16px 24px',
    },
});

export default MuiDialogActions;
